
import axios from 'axios';
import { ContextMenuNode } from 'types/Sapphire_dto';
import ContextMenuItem from './ContextMenuItem.vue';
import Vue from 'vue'

const ContextMenu = Vue.extend({
  name: "context-menu",
  components: {  ContextMenuItem },
  props: {
    menuTypeID: Number
  },
  data: function () {
    return {
      contextMenuItems: [] as ContextMenuNode[],
    };
  },
  mounted: function () {
    this.getMenuItems();
  },
  methods: {
    async getMenuItems(parameters?: string) {
      this.contextMenuItems.length = 0;
      switch (this.menuTypeID) {
        case 1:                 
          await axios
              .post(
              "../../../Common/Services/EhrTaskService.svc/GetDentalContextMenuItems",
              {
                SelectedTeethLength: parameters
              }
              )
              .then((response) => {
              this.contextMenuItems = JSON.parse(response.data.d);
          });
        break;
      }
    },
    menuItemClicked(clickEvent: string, parameterString?: string) {
      if (parameterString)
        this.$emit(clickEvent, parameterString);
      else 
        this.$emit(clickEvent);    
      }
  },
});

export type ContextMenuRef = InstanceType<typeof ContextMenu>;
export default ContextMenu;

